import { FC, useCallback, useEffect, useState } from 'react'
import BadgeCount from './BadgeCount'
import Popout from '../Popout'
import ChangeCount from './ChangeCount'
import { BadgeName } from 'src/app/types'

type InteractiveBadgeProps = {
  name: BadgeName
  initialCount: number
  setBadgeCount: ({ name, count }: { name: BadgeName; count: number }) => void
}

const InteractiveBadge: FC<InteractiveBadgeProps> = ({
  name,
  initialCount,
  setBadgeCount,
}) => {
  const [count, setCount] = useState(initialCount)

  useEffect(() => {
    // if the initialCount changes, update our internal count
    setCount(initialCount)
  }, [initialCount, setCount])

  const increaseCount = useCallback(() => setCount(count + 1), [count])

  // needs special behavior for removal not past 0, force update if zero is reached
  const decreaseCount = useCallback(() => {
    if (count > 1) setCount(count - 1)
    else setBadgeCount({ name, count: 0 })
  }, [count, setBadgeCount, name])

  // if the popout is no longer open
  const onIsOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) {
        setBadgeCount({ name, count })
      }
    },
    [count, setBadgeCount, name]
  )
  return (
    <Popout
      popoutClass="z-[60]"
      onIsOpen={onIsOpen}
      contents={
        <ChangeCount
          count={count}
          id={name}
          onIncrement={increaseCount}
          onDecrement={decreaseCount}
        />
      }
    >
      {({ isOpen }) => (
        <BadgeCount name={name} count={initialCount} isOpen={isOpen} />
      )}
    </Popout>
  )
}

export default InteractiveBadge
